import React from 'react'
import { GridItem } from '@entur/grid'

type Layout4Props = {
  children: React.ReactNode
  [key: string]: unknown
}
export const Layout4: React.FC<Layout4Props> = (props) => {
  return (
    <>
      <GridItem medium={4} large={4} />
      <GridItem small={12} medium={4} large={4}>
        {props.children}
      </GridItem>
      <GridItem medium={4} large={4} />
    </>
  )
}
